import { Radio } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { PIC } from "@ryde/assets";
import { StationsBulkActionSourceEnum } from "@ryde/shared";

import { StationsBulkMultiSelect } from "./stations-bulk-multi-select";
import { StationsMapBulkTargetPanelStyled } from "./stations.map.styled";
import { useStationsBulkTarget } from "./use-stations-bulk-target";

export const StationsMapBulkTargetPanel: FC = () => {
  const { t } = useTranslation();
  const {
    source,
    setSource,
    closePanel,
    gridSelectedIds,
    setGridSelectedIds,
    mapSelectedIds,
    setMapSelectedIds,
    allStationIds,
    getOptionLabel,
    isAllCheckboxSelected,
    toggleAllCheckbox,
    isAllMarkersSelected,
    toggleAllMarkers,
  } = useStationsBulkTarget();

  return (
    <StationsMapBulkTargetPanelStyled>
      <div className="panel-content">
        <div className="panel-title">{t("station.mapBulkActionTitle")}</div>

        <div className="panel-row">
          <Radio
            checked={source === StationsBulkActionSourceEnum.checkbox}
            onChange={() => setSource(StationsBulkActionSourceEnum.checkbox)}
          />
          <div className="dropdownInput">
            <StationsBulkMultiSelect
              label={t("station.mapBulkCheckboxSelection")}
              options={allStationIds}
              value={gridSelectedIds}
              onChange={setGridSelectedIds}
              getOptionLabel={getOptionLabel}
              isAllSelected={isAllCheckboxSelected}
              onToggleAll={toggleAllCheckbox}
            />
          </div>
        </div>

        <div className="panel-row">
          <Radio
            checked={source === StationsBulkActionSourceEnum.markers}
            onChange={() => setSource(StationsBulkActionSourceEnum.markers)}
          />
          <div className="dropdownInput">
            <StationsBulkMultiSelect
              label={t("station.mapBulkMarkerSelection")}
              options={gridSelectedIds}
              value={mapSelectedIds}
              onChange={setMapSelectedIds}
              getOptionLabel={getOptionLabel}
              isAllSelected={isAllMarkersSelected}
              onToggleAll={toggleAllMarkers}
            />
          </div>
        </div>
      </div>

      <PIC.XSVG className="close-icon-svg" onClick={closePanel} />
    </StationsMapBulkTargetPanelStyled>
  );
};
